const API_BASE_URL =
  "https://hospital-enrollment-backend-production.up.railway.app";

class ApiService {
  constructor() {
    this.baseURL = API_BASE_URL;
    this.logoutCallback = null;
  }

  // Register logout callback to be called on 401/403
  setLogoutCallback(callback) {
    this.logoutCallback = callback;
  }

  async request(endpoint, options = {}) {
    const url = `${this.baseURL}${endpoint}`;
    const token = localStorage.getItem("authToken");

    const config = {
      headers: {
        "Content-Type": "application/json",
        ...(token && { Authorization: `Bearer ${token}` }),
        ...options.headers,
      },
      ...options,
    };

    try {
      const response = await fetch(url, config);
      const data = await response.json();

      if (!response.ok) {
        // Handle authentication errors - logout user
        if (response.status === 401 || response.status === 403) {
          console.warn("Authentication error:", response.status);
          // Call logout callback if registered
          if (this.logoutCallback) {
            this.logoutCallback();
          }
          throw new Error(
            data.message || "Session expired. Please login again."
          );
        }
        throw new Error(data.message || "Request failed");
      }

      return data;
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  }

  // Hospital endpoints
  async getHospitals(status = "new", page = 1, limit = 10) {
    return this.request(
      `/hospitals?status=${status}&page=${page}&limit=${limit}`
    );
  }

  async getHospitalsByStatus(status) {
    return this.request(`/hospitals?status=${status}&page=1&limit=100`);
  }

  async getHospitalById(id) {
    return this.request(`/hospitals/${id}`);
  }

  async updateHospitalStatus(id, status) {
    return this.request(`/hospitals/${id}/status`, {
      method: "PUT",
      body: JSON.stringify({ status }),
    });
  }

  async getHospitalDocuments(id) {
    return this.request(`/hospitals/${id}/documents`);
  }

  // Hospital application submission
  async submitHospitalApplication(formData) {
    const url = `${this.baseURL}/hospitals`;

    try {
      const response = await fetch(url, {
        method: "POST",
        body: formData,
      });

      const data = await response.json();

      if (!response.ok) {
        // Handle authentication errors - logout user
        if (response.status === 401 || response.status === 403) {
          console.warn("Authentication error:", response.status);
          // Call logout callback if registered
          if (this.logoutCallback) {
            this.logoutCallback();
          }
          throw new Error(
            data.message || "Session expired. Please login again."
          );
        }
        throw new Error(data.message || "Failed to submit application");
      }

      return data;
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  }

  // Auth endpoints
  async login(username, password, recaptchaToken) {
    return this.request("/hospitals/login", {
      method: "POST",
      body: JSON.stringify({ username, password, recaptchaToken }),
    });
  }

  async logout() {
    return this.request("/hospitals/logout", {
      method: "POST",
    });
  }
}

export default new ApiService();
